import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, FormField, Grid } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import {
  GetCustomerAssetsList,
  AddorUpdateAssetToFacility,
} from '../../../services/asset'
import IntelMsg from '../../ItelMsg'

const formValidator = {
  country: yup.string().trim().required('You Must Select A Country'),
  region: yup.string().trim().required('You Must Select A Region'),
  facility: yup.string().trim().required('You Must Select A Facility'),
}

const UpdateHierarchyModal = ({ asset, setOpen, open }) => {
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [facilities, setFacilities] = useState([])
  const [selectedCountry, setSelectedCountry] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })
  useEffect(() => {
    ;(async () => {
      const productName = await localStorage.getItem('product')
      if (open) {
        const res = await GetCustomerAssetsList(
          asset.userEmail,
          'country',
          productName,
          asset.customerId,
        )
        console.log('countries: ', res)
        setCountries(res.data)
      }
    })()
  }, [open])
  console.log('modal asset: ', asset)

  const updateHierarchy = async (data) => {
    console.log(selectedCity, selectedCountry, data.facility.split(',')[0])
    const queryParams = {
      fromId: data.facility.split(',')[0],
      toId: asset['asset id'],
      facility: data.facility.split(',')[1],
      country: selectedCountry,
      city: selectedCity,
    }
    Swal.showLoading()
    const res = await AddorUpdateAssetToFacility(queryParams)
    if (res.success) {
      await Swal.fire({
        title: 'Hierarchy Updated Successfully!',
        confirmButtonColor: 'Green',
        icon: 'success',
      })
      setOpen(false)
    } else {
      Swal.fire({
        title: 'Error Updating Hierarchy!',
        confirmButtonColor: 'Red',
        icon: 'error',
      })
    }
  }

  const handleCountryChange = async (e) => {
    setSelectedCountry(e.target.value.split(',')[1])
    setSelectedCity('')
    const productName = await localStorage.getItem('product')
    setFacilities([])
    const res = await GetCustomerAssetsList(
      asset.userEmail,
      'Region',
      productName,
      asset.customerId,
      e.target.value.split(',')[0],
    )
    const newRegions = res.data.filter(
      (r) => r['asset type'].toLowerCase() === 'region',
    )
    setRegions(newRegions)
  }

  const handleRegionChange = async (e) => {
    setSelectedCity(e.target.value.split(',')[1])
    const productName = await localStorage.getItem('product')
    const res = await GetCustomerAssetsList(
      asset.userEmail,
      'Facility',
      productName,
      asset.customerId,
      e.target.value.split(',')[0],
    )
    const newFacilities = res.data.filter(
      (r) => r['asset type'].toLowerCase() === 'facility',
    )
    setFacilities(newFacilities)
  }
  return (
    <Modal open={open}>
      <Modal.Header style={{ backgroundColor: '#4b6587', color: '#FFF' }}>
        Update Hierarchy
      </Modal.Header>
      <Modal.Content>
        <Form
          id="editForm"
          style={{
            backgroundColor: 'rgb(216, 231, 234)',
            padding: 10,
            borderRadius: 9,
          }}
          onSubmit={handleSubmit(updateHierarchy)}
        >
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <p>
                  <b>Asset Name:</b>{' '}
                  {asset['asset label'] || asset['asset name']}
                </p>
              </Grid.Column>

              <Grid.Column>
                <p>
                  <b>Asset Type:</b> {asset['asset type']}
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <hr />
          <br />
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <FormField>
                  <strong>Select Country</strong>
                  <select
                    name="country"
                    ref={register}
                    onChange={handleCountryChange}
                  >
                    {/* <option value=""> </option> */}
                    {countries.map((country) => (
                      <option
                        key={country['asset id']}
                        value={`${country['asset name']},${
                          country['asset label'] || country['asset name']
                        }`}
                      >
                        {country['asset label'] || country['asset name']}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <small style={{ color: 'red' }}>
                      {errors.country.message}
                    </small>
                  )}
                </FormField>
              </Grid.Column>
              <Grid.Column>
                <FormField>
                  <strong>Select Region</strong>
                  <select
                    name="region"
                    ref={register}
                    onChange={handleRegionChange}
                  >
                    {/* <option value=""> </option> */}
                    {regions.map((region) => (
                      <option
                        key={region['asset id']}
                        value={`${region['asset name']},${
                          region['asset label'] || region['asset name']
                        }`}
                      >
                        {region['asset label'] || region['asset name']}
                      </option>
                    ))}
                  </select>
                  {errors.region && (
                    <small style={{ color: 'red' }}>
                      {errors.region.message}
                    </small>
                  )}
                </FormField>
              </Grid.Column>
              <Grid.Column>
                <FormField>
                  <strong>Select Facility</strong>
                  <select name="facility" ref={register}>
                    facility
                    {/* <option value=""> </option> */}
                    {facilities.map((facility) => (
                      <option
                        key={facility['asset id']}
                        value={`${facility['asset id']},${
                          facility['asset label'] || facility['asset name']
                        }`}
                      >
                        {facility['asset label'] || facility['asset name']}
                      </option>
                    ))}
                  </select>
                  {errors.facility && (
                    <small style={{ color: 'red' }}>
                      {errors.facility.message}
                    </small>
                  )}
                </FormField>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <hr />
          <br />
          <Button type="submit" color="blue">
            <IntelMsg id="submit" />
          </Button>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  )
}

UpdateHierarchyModal.propTypes = {
  open: Proptypes.bool,
  asset: Proptypes.object,
  setOpen: Proptypes.func,
}

export default UpdateHierarchyModal
